import React, { useState } from "react";
import Layout from "../../components/admin/Layout";
import Helmet from "react-helmet";
import HomePageBanner from "../../components/admin/setting/HomePageBanner";
import SiteSetting from "../../components/admin/setting/SiteSetting";
import SupportInfo from "../../components/admin/setting/SupportInfo";
import SeoSetting from "../../components/admin/setting/SeoSetting";
import PolicyInfo from "../../components/admin/setting/PolicyInfo";
import Page from "../../components/admin/setting/Page";
import { useSelector } from "react-redux";

const tabs = [
  { name: "Site Setting", key: "site_setting" },
  { name: "Support Info", key: "support" },
  { name: "SEO Setting", key: "seo" },
  { name: "Policy", key: "policy" },
  { name: "Pages", key: "pages" },
  { name: "Slider", key: "banner" },
];

const Setting = () => {
  const [activeTab, setActiveTab] = useState("site_setting");
  const BRAND_NAME = useSelector(
    (state) => state.globalState?.siteSetting?.site_settings?.site_name
  );
  return (
    <Layout>
      <Helmet>
        <title>Setting - {BRAND_NAME ?? ''}</title>
      </Helmet>

      <div className="p-4">
        <div className="relative mb-2 overflow-x-auto border-b rounded-md shadow-sm hide-scrollbar scroll-smooth bg-white/60 backdrop-blur-sm">
          <div className="relative flex gap-4 px-4 py-2 min-w-max">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`relative px-4 py-1.5 text-sm font-medium whitespace-nowrap rounded-full transition-all duration-300 ${
                  activeTab === tab.key
                    ? "text-white bg-primary shadow-md"
                    : "text-gray-500 hover:bg-primary/10 hover:text-primary"
                }`}
              >
                {tab.name
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (c) => c.toUpperCase())}
              </button>
            ))}
          </div>
        </div>

        {/* Tabs Content */}
        <div className="space-y-6">
          {activeTab === "site_setting" && <SiteSetting />}
          {activeTab === "support" && <SupportInfo />}
          {activeTab === "seo" && <SeoSetting />}
          {activeTab === "policy" && <PolicyInfo />}
          {activeTab === "pages" && <Page />}
          {activeTab === "banner" && <HomePageBanner />}
        </div>
      </div>
    </Layout>
  );
};

export default Setting;
